/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationByOptimizationTypesRequest {
    getFixupPrototypeFunction() { return CostOptimizationByOptimizationTypesRequest.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationByOptimizationTypesRequest>): CostOptimizationByOptimizationTypesRequest {
        let obj = Object.assign(new CostOptimizationByOptimizationTypesRequest(), model);
        CostOptimizationByOptimizationTypesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationByOptimizationTypesRequest>): CostOptimizationByOptimizationTypesRequest {
        if (!model) return null;
        return CostOptimizationByOptimizationTypesRequest.newInstance(<CostOptimizationByOptimizationTypesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationByOptimizationTypesRequest) {
        if (!obj) return;

        models.CostOptimizationByOptimizationTypesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationByOptimizationTypesRequest): boolean {
        Object.setPrototypeOf(obj, CostOptimizationByOptimizationTypesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filter) {
            models.AccountFilters.fixupPrototype(this.filter);
        }
    }

    filter: models.AccountFilters;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    /**
     * Deduplication of the data
     */
    deduplication: boolean = false;

}
